import { useField, useFormikContext } from "formik";
import Switch from "react-switch";

const QuestionAttendance = ({ question }) => {
  const [field, meta, helpers] = useField(`${question?.id}.answer`);

  const handleChange = (checked) => {
    helpers.setValue(checked ? "absent" : "present");
  }

  return (
    <div>
      <div className=" d-flex align-items-center">
        <p className="m-0 text-muted mx-1">Present</p>
        <Switch
          uncheckedIcon={""}
          checkedIcon={""}
          onHandleColor={"#A3DF00"}
          offHandleColor={"#A3DF00"}
          onColor={"#E6E6E6"}
          offColor={"#E6E6E6"}
          height={18}
          width={40}
          onChange={handleChange}
          checked={field?.value === "absent"}
        />
        <p className="m-0 text-muted mx-1">Absent</p>
      </div>
      {meta.touched && meta.error && (
        <div className="error">
          {meta.error}
        </div>
      )}
    </div>
  )
}

export default QuestionAttendance;